import { apiClient } from '@/lib/api';
import type {
  Contract,
  CreateContractData,
  UpdateContractData,
  ContractListResponse,
  ContractType,
  ContractStatus,
} from '../types/contract.types';

export interface ContractListParams {
  status?: ContractStatus;
  type?: ContractType;
  isTemplate?: 'true' | 'false';
  quoteId?: string;
  page?: number;
  limit?: number;
}

export const contractService = {
  list: (params?: ContractListParams) =>
    apiClient.get<ContractListResponse>('/api/contracts', {
      params,
    }),

  getById: (id: string) => apiClient.get<Contract>(`/api/contracts/${id}`),

  create: (data: CreateContractData) => apiClient.post<Contract>('/api/contracts', data),

  update: (id: string, data: UpdateContractData) =>
    apiClient.put<Contract>(`/api/contracts/${id}`, data),

  remove: (id: string) => apiClient.delete(`/api/contracts/${id}`),

  clone: (id: string) => apiClient.post<Contract>(`/api/contracts/${id}/clone`),

  generateFromQuote: (quoteId: string) =>
    apiClient.post<Contract>(`/api/contracts/generate-from-quote/${quoteId}`),
};
